import { HTML5Backend } from "react-dnd-html5-backend";
import { createTransition, TouchTransition } from "react-dnd-multi-backend";
import { TouchBackend } from "react-dnd-touch-backend";

export const HTML5toTouch = {
  backends: [
    {
      id: "html5",
      backend: HTML5Backend,
      transition: createTransition("touchstart", (event) => {
        return false; // disable HTML5 drag on touch devices
      }),
    },
    {
      id: "touch",
      backend: TouchBackend,
      options: { enableMouseEvents: true, delayTouchStart: 0 }, // 👈 delayTouchStart=0 to reduce delay
      preview: true,
      transition: TouchTransition,
    },
  ],
};

export const TRAITS = ["cleanliness", "reliability", "fun"];

export const MAP_TRAIT_LABEL = {
  cleanliness: "Propreté",
  reliability: "Efficace",
  fun: "Agréable",
};
